<script setup>
import { computed, defineProps } from "vue"

import Navigation from "../modules/Navigation/NavigationInset.vue"

import styles from "@/styles/settings.module.scss"
// import { useStore } from "../utils"

// const store = useStore()

const props = defineProps({
  backgroundColor: String,
  uiColor: String,
  dynamicOpacityThreshold: Number,
  float: Boolean
  /* backgroundImage: Object */
})

const getUiColour = computed(() => {
  return props.uiColor || styles["COLOUR_bleach_black"]
})

// const GET_IS_ABOVE_BREAKPOINT = store.getters["breakpoints/GET_IS_ABOVE_BREAKPOINT"]
</script>

<template>
  <section
    class="page-section generic-section"
    :class="[props.float ? '' : 'generic-section--no-float']"
    :style="{
      backgroundColor: backgroundColor || styles['COLOUR_bleach_offwhite']
    }"
  >
    <Navigation
      :backgroundColor="backgroundColor"
      :uiColor="getUiColour"
      :dynamicOpacityThreshold="dynamicOpacityThreshold"
    >
      <template v-slot:background>
        <slot name="nav-background"></slot>
      </template>
    </Navigation>
    <slot></slot>
  </section>
</template>

<style lang="scss">
.page-section {
  clip-path: inset(-1px 0 -1px 0);
  overflow: clip;
}
</style>
